import { render } from "./VoucherOrganizationDetail.vue?vue&type=template&id=d496ef68&scoped=true"
import script from "./VoucherOrganizationDetail.vue?vue&type=script&lang=js"
export * from "./VoucherOrganizationDetail.vue?vue&type=script&lang=js"

import "./VoucherOrganizationDetail.vue?vue&type=style&index=0&id=d496ef68&lang=scss&scoped=true"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-d496ef68"]])

export default __exports__